import ProjectService from '@/services/project.service';
import axios from "axios";

export const projectModule = {
    namespaced: true,
    state: {
        requests: [],
        project: {},
        projects: new Map(),
        submitted: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createProject({commit, dispatch}, {classId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createProject");
            return ProjectService.createProject(axiosSource, classId, data).then(
                async data => {
                    commit('insertProject', data)
                    await dispatch('clearRequest', "createProject");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateProject({commit, dispatch}, {classId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateProject");
            return ProjectService.updateProject(axiosSource, classId, data).then(
                async data => {
                    commit('updateProjectData', data)
                    await dispatch('clearRequest', "v");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteProject({commit, dispatch}, {classId, projectId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteProject");
            return ProjectService.deleteProject(axiosSource, classId, projectId).then(
                async data => {
                    commit('removeProjectFromList', projectId)
                    await dispatch('clearRequest', "deleteProject");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getProject({commit, dispatch}, {classId, projectId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getProject");
            return ProjectService.getProject(axiosSource, classId, projectId).then(
                async data => {
                    commit('updateActiveProject', data)
                    await dispatch('clearRequest', "getProject");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listProjects({commit, dispatch}, classId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listProjects");
            return ProjectService.listProjects(axiosSource, classId).then(
                async data => {
                    commit('updateProjectsList', data);
                    await dispatch('clearRequest', "listProjects");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listUserProjects({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listUserProjects");
            return ProjectService.listUserProjects(axiosSource).then(
                async data => {
                    commit('updateProjectsList', data);
                    await dispatch('clearRequest', "listUserProjects");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async submitProject({commit, dispatch}, {classId, projectId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "submitProject");
            return ProjectService.submitProject(axiosSource, classId, projectId, data).then(
                async data => {
                    commit('submitProject', data)
                    await dispatch('clearRequest', "submitProject");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async submitted({commit, dispatch}, {classId, projectId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "projectSubmitted");
            return ProjectService.submitted(axiosSource, classId, projectId).then(
                async data => {
                    commit('updateSubmitted', data)
                    await dispatch('clearRequest', "projectSubmitted");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateProjectsList(state, data) {
            state.projects = new Map()
            for (const entity of data) {
                state.projects.set(entity.id, entity)
            }
        },
        updateSubmitted(state, data) {
            state.submitted = new Map()
            for (const entity of data) {
                state.submitted.set(entity.created_at, entity)
            }
        },
        insertProject(state, data) {
            state.projects.set(data.id, data)
        },
        updateProjectData(state, data) {
            state.projects.set(data.id, data)
        },
        removeProjectFromList(state, projectId) {
            state.projects.delete(projectId)
        },
        updateActiveProject(state, data) {
            state.project = data;
        }
    }
};